var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Skeleton as MSkeleton, } from '@mui/material';
import Card from '../card';
export var variants = ['card', 'paragraph', 'image'];
function CardSkeleton() {
    return (_jsxs(Card, __assign({ pfVariant: "default" }, { children: [_jsx(Box, __assign({ sx: { p: '1em 1em 0' } }, { children: _jsx(MSkeleton, { animation: "wave", height: 30, width: "80%" }) })), _jsx(MSkeleton, { sx: { height: 190, m: 1 }, animation: "wave", variant: "rounded" })] })));
}
function ParagraphSkeleton() {
    return (_jsxs(_Fragment, { children: [_jsx(MSkeleton, { animation: "wave", height: 50, width: "30%" }), _jsx(MSkeleton, { animation: "wave", height: 30, width: "80%" }), _jsx(MSkeleton, { animation: "wave", height: 30, width: "80%" })] }));
}
function ImageSkeleton() {
    return (_jsxs(_Fragment, { children: [_jsx(MSkeleton, { sx: { height: 190 }, animation: "wave", variant: "rounded" }), _jsx(MSkeleton, { animation: "wave", height: 30 })] }));
}
var variantMap = {
    card: _jsx(CardSkeleton, {}),
    paragraph: _jsx(ParagraphSkeleton, {}),
    image: _jsx(ImageSkeleton, {}),
};
export default function PFCard(_a) {
    var sx = _a.sx, pfVariant = _a.pfVariant, props = __rest(_a, ["sx", "pfVariant"]);
    if (pfVariant) {
        return variantMap[pfVariant];
    }
    return _jsx(MSkeleton, __assign({ sx: __assign({}, sx) }, props));
}
